import Api from "@/services/Api";
import BaseApi from "../../../services/baseApi";

class Service {
    constructor() {
        this.entity = 'subscription';
    }

  getById(id) {
      if(id && id.length>0) {
          return Api.getById(this.entity, id)
      }else {
          return Api.new_(this.entity)
      }
    }

    delete(id) {
        return Api.delete(this.entity,id)
    }

    getPage() {
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            url: '/private/'+this.entity+'/list',
            headers: {'Content-Type': 'application/json'},
        })
    }
    getSubscription() {
        return BaseApi({requiresAtuh: true})({
            method: 'GET',
            url: '/private/'+this.entity+'/getSubscription',
            headers: {'Content-Type': 'application/json'},
        })
    }

   save(model) {
        return Api.save(this.entity,model)
    }





}
export default new Service();
